__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-28-1790597554-stable-dev/";